// extracted by css-extract-rspack-plugin
var _1 = "M3UPeoMvzszzrE67";
var _2 = "wKOfcdM5sJYFplxb";
export { _1 as "badgeBaseStyle", _2 as "labelStyle" }
